import { render, staticRenderFns } from "./docTab.vue?vue&type=template&id=efb7c566&scoped=true"
import script from "./docTab.vue?vue&type=script&lang=js"
export * from "./docTab.vue?vue&type=script&lang=js"
import style0 from "./docTab.vue?vue&type=style&index=0&id=efb7c566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb7c566",
  null
  
)

export default component.exports